module.exports = __webpack_public_path__ + "static/media/128tick.06f95c6b.mp4";